const getters = {
  user: state => state.user,
  allowCookies: state => state.allowCookies,
  loginEmail: state => state.loginEmail,
  chatOptions: state => state.chatOptions,
  storedPinwalls: state => state.storedPinwalls,
  storedSpaces: state => state.storedSpaces,
  storedLikes: state => state.storedLikes,
  currentScrollPosition: state => state.currentScrollPosition,
  userClickedOnMedia: state => state.userClickedOnMedia,
  playingMode: state => state.playingMode,
  darkMode: state => state.darkMode
};

const actions = {
  getIdentity(context, token) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/getToken?token=${token}`,
        {
          method: "get"
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          if (data.refresh_token) {
            context.commit("setUser", data);
            return resolve();
          }

          reject(data);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  setUsername(context, data) {
    data.token = context.getters.user.refresh_token;
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/setUsername`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          if (data.refresh_token) {
            context.commit("setUser", data);
            return resolve();
          }

          reject(data);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  updateStats(context, data) {
    data.token = context.getters.user.refresh_token;

    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/updateStats`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          if (data.refresh_token) {
            context.commit("setUser", data);
            return resolve();
          }

          reject(data);
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  changePassword(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/changePassword`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          if (res.ok) {
            resolve();
          }
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  changePhoto(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/changePhoto?token=${context.getters.user.access_token}`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          if (res.ok) {
            resolve();
          }
        })
        .catch(e => {
          console.error(e);
          reject();
        });
    });
  },
  forgotPassword(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
          process.env.VUE_APP_IDENTITY_API
        }/forgotPassword?email=${data.email}&lang=${data.lang}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          resolve(data);
        })
        .catch(e => {
          console.log(e);
          reject();
        });
    });
  }
};

const mutations = {
  setChatOptions(state, data) {
    state.chatOptions = data;
  },
  setStoredPinwall(state, pinwall) {
    // pinwall.password =
    //   pinwall.password && typeof pinwall.password === "string"
    //     ? encrypt(pinwall.password)
    //     : null;
    let found = false;
    state.storedPinwalls.map(item => {
      if (
        item.pinwallId === pinwall.pinwallId &&
        item.userId === pinwall.userId
      ) {
        item.view = pinwall.view || item.view;
        item.sort = pinwall.sort || item.sort;
        item.password = pinwall.password;
        found = true;
      }
    });

    if (!found) {
      state.storedPinwalls.push(pinwall);
    }
  },
  setStoredSpace(state, space) {
    // space.password =
    //   space.password && typeof space.password === "string"
    //     ? encrypt(space.password)
    //     : null;
    let found = false;
    state.storedSpaces.map(item => {
      if (item.space === space.space && item.userId === space.userId) {
        item.password = space.password;
        item.sort = space.sort;
        found = true;
      }
    });
    if (!found) {
      state.storedSpaces.push(space);
    }
  },
  setStoredLike(state, like) {
    let foundLike = state.storedLikes.find(item => {
      return item === like;
    });
    if (!foundLike) {
      state.storedLikes.push(like);
    }
  },
  setCurrentScrollPosition(state, position) {
    state.currentScrollPosition = position;
  },
  setUser(state, user) {
    state.user = user;
  },
  setUserClickedOnMedia(state, clicked) {
    state.userClickedOnMedia = clicked;
  },
  setLoginEmail(state, loginEmail) {
    state.loginEmail = loginEmail;
  },
  setUserPhoto(state, photo) {
    state.user.photo = photo;
  },
  setAllowCookies(state, allow) {
    state.allowCookies = allow;
  },
  logout(state) {
    state.user = null;
  },
  setPlayingMode(state, mode) {
    state.playingMode = mode;
  },
  setDarkMode(state, darkMode) {
    state.darkMode = darkMode;
  },
  setLocale(state, locale) {
    state.locale = locale;
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    user: null,
    locale: "en",
    allowCookies: false,
    userClickedOnMedia: false,
    loginEmail: null,
    darkMode: true,
    chatOptions: null,
    storedPinwalls: [],
    storedSpaces: [],
    storedLikes: [],
    currentScrollPosition: 0,
    playingMode: "playlist-play"
  };
}
